import React from "react";
import {
    GET_GENERIC_GROUP,
    SAVE_GENERIC_GROUP,
    EDIT_GENERIC_GROUP,
    GENERIC_GROUP_REQUEST_BEGIN,
    GENERIC_GROUP_REQUEST_ABORT,
    
    AUTH_ERROR,
} from './types';

import axiosWrapper from "../utils/axiosWrapper";

import { mapGenericGroupfilters } from "../utils/mappers/genericGroups";

import _ from "lodash";

import { toast } from "react-toastify";

import ToastI18nWrapper from "../components/ToastI18nWrapper/ToastI18nWrapper";

export const getGenericGroups = (currentWorkspaceId, inBackground = false) => async (
    dispatch
) => {
    
    if (!currentWorkspaceId) {
        dispatch({
            type: GET_GENERIC_GROUP,
            payload: [],
        });
        return;
    }
    const payload = {}
    payload.genericGroupRequestBegin = true
    try {
        if (!inBackground) {
            dispatch({ type: GENERIC_GROUP_REQUEST_BEGIN, payload: payload });
        }
        const response = await axiosWrapper.get(
            `/generic-groups?current_workspace_id=${currentWorkspaceId}`
        );
        dispatch({
            type: GET_GENERIC_GROUP,
            payload: response.data.map((group) => mapGenericGroupfilters(group))
        });
    } catch (error) {
        if (!_.isNil(error.response) && error.response.status === 401) {
            dispatch({ type: AUTH_ERROR });
        }
        dispatch({ type: GENERIC_GROUP_REQUEST_ABORT });
    }
    payload.genericGroupRequestBegin = false
    dispatch({ type: GENERIC_GROUP_REQUEST_BEGIN, payload: payload })
};

export const saveGenericGroup = (
    currentWorkspaceId,
    group,
) => async (dispatch, getState) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
        },
    };

    const filters = _.pick(group, Object.keys(getState().dataset.columns));

    const rawBody = {
        current_workspace_id: currentWorkspaceId,
        name: group.name,
        description: group.description || "",
        group_type: group.group_type,
        filters: filters,
    };

    const body = JSON.stringify(rawBody);
    const payload = {}
    payload.genericGroupRequestBegin = true

    try {
        dispatch({
            type: GENERIC_GROUP_REQUEST_BEGIN,
            payload: payload
        });
        await axiosWrapper.post("/generic-groups", body, config);
        dispatch({
            type: SAVE_GENERIC_GROUP,
        });
    } catch (error) {
        dispatch({ type: GENERIC_GROUP_REQUEST_ABORT, });
        dispatch(getGenericGroups(currentWorkspaceId));

        if (!_.isNil(error.response)) {
            switch (error.response.status) {
                case 401:
                    dispatch({ type: AUTH_ERROR });

                    break;
                default:
                    toast.error(<ToastI18nWrapper translateKey={"genericError"} />, {
                        toastId: "genericError",
                    });
                    break;
            }
        } else {
            toast.error(<ToastI18nWrapper translateKey={"genericError"} />, {
                toastId: "genericError",
            });
        }
    }
    payload.genericGroupRequestBegin = false
    dispatch({
        type: GENERIC_GROUP_REQUEST_BEGIN,
        payload: payload
    });
    dispatch(getGenericGroups(currentWorkspaceId))
};

export const editGenericGroup = (
    currentWorkspaceId,
    group,
    isCurrentOrderTableCommitted
) => async (dispatch, getState) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
        },
    };

    const filters = _.pick(group, Object.keys(getState().dataset.columns));

    const rawBody = {
        current_workspace_id: currentWorkspaceId,
        id: group.id,
        name: group.name,
        description: group.description || "",
        group_type: group.group_type,
        filters: filters,
        calculation_required: !isCurrentOrderTableCommitted
    };
    const body = JSON.stringify(rawBody);
    const payload = {}
    payload.genericGroupRequestBegin = true

    try {
        dispatch({
            type: GENERIC_GROUP_REQUEST_BEGIN,
            payload: payload
        });
        const response = await axiosWrapper.put("/generic-groups", body, config);
        const group = response.data;
        dispatch({
            type: EDIT_GENERIC_GROUP,
            payload: mapGenericGroupfilters(group),
        });
        getGenericGroups(currentWorkspaceId)

    } catch (error) {
        dispatch({ type: GENERIC_GROUP_REQUEST_ABORT });
        dispatch(getGenericGroups(currentWorkspaceId));

        if (!_.isNil(error.response)) {
            switch (error.response.status) {
                case 401:
                    dispatch({ type: AUTH_ERROR });
                    break;
                default:
                    toast.error(<ToastI18nWrapper translateKey={"genericError"} />, {
                        toastId: "genericError",
                    });
                    break;
            }
        } else {
            toast.error(<ToastI18nWrapper translateKey={"genericError"} />, {
                toastId: "genericError",
            });
        }
    }
    payload.genericGroupRequestBegin = false
    dispatch({ type: GENERIC_GROUP_REQUEST_BEGIN, payload: payload })
    dispatch(getGenericGroups(currentWorkspaceId))
};

export const removeGenericGroup = (
    currentWorkspaceId,
    groupId,
) => async (dispatch) => {
    console.log('on call delete group')
    
    const config = {
        headers: {
            "Content-Type": "application/json",
        },
        data: JSON.stringify({
            id: groupId,
            current_workspace_id: currentWorkspaceId,
        }),
    };
    const genericGroupRequestBegin = {}
    genericGroupRequestBegin.genericGroupRequestBegin = true
    try {
        dispatch({
            type: GENERIC_GROUP_REQUEST_BEGIN,
            payload: genericGroupRequestBegin
            // payload: true
        });
        // const response = 
        await axiosWrapper.delete("/generic-groups", config);

    } catch (error) {
        dispatch({ type: GENERIC_GROUP_REQUEST_ABORT });
        genericGroupRequestBegin.genericGroupRequestBegin = false
        dispatch({ type: GENERIC_GROUP_REQUEST_BEGIN, payload: genericGroupRequestBegin })
        if (!_.isNil(error.response)) {
            if (error.response.status === 401) {
                dispatch({ type: AUTH_ERROR });
            } else if (error.response.status === 412) {
                toast.error(
                    <ToastI18nWrapper translateKey={"groupSettings.groupRemoveError"} />,
                    { toastId: "groupRemoveError" }
                );
            }
        } else {
            toast.error(<ToastI18nWrapper translateKey={"genericError"} />, {
                toastId: "genericError",
            });
        }
    }
    genericGroupRequestBegin.genericGroupRequestBegin = false
    dispatch({ type: GENERIC_GROUP_REQUEST_BEGIN, payload: genericGroupRequestBegin })
    dispatch(getGenericGroups(currentWorkspaceId))
};
